var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"u-user-message"},[_c('Badge',{attrs:{"count":1000,"overflow-count":_vm.overflowCount}},[_c('Icon',{attrs:{"type":"md-notifications-outline","size":"24"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }